import { createContext, useContext } from 'react';

const TableRowSelectedContext = createContext<boolean | undefined>(undefined);
export const TableRowSelectedProvider = TableRowSelectedContext.Provider;

export const useTableRowSelected = (controlledValue?: boolean, defaultValue: boolean = false) => {
  const tableRowSelected = useContext(TableRowSelectedContext);
  return controlledValue ?? tableRowSelected ?? defaultValue;
};
